import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import CohortChartDropdownItems from './CohortChartDropdownItems';

const CohortChartDropdown = ({ chart, disabled, onChange }) => {
  const intl = useIntl();
  return (
    <Dropdown
      item
      className="aridhia-cohort-chart-dropdown active max-content"
      disabled={disabled}
      text={intl.formatMessage({ id: `chart.${chart.toLowerCase()}` })}
    >
      <Dropdown.Menu>
        <Dropdown.Header content={intl.formatMessage({ id: 'chart.select.header' })} />
        <CohortChartDropdownItems value={chart} onChange={onChange} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CohortChartDropdown;
